(() => {
  const updates = [];
  document.querySelectorAll('[data-page-cart], [data-drawer-cart]').forEach(page => {
  let count = Number(page.dataset.itemCount) || 0;
  function minimumItems() {
    return (window.Shopify?.country || page.dataset.country) === 'GB' ? 5 : 10;
  }
  function update(nextCount) {
    const instant = window.fbCartInstantState?.();
    if (instant) count = instant.itemCount;
    else if (Number.isFinite(Number(nextCount))) count = Number(nextCount);
    const minimum = minimumItems();
    const remaining = Math.max(0, minimum - count);
    const blocked = remaining > 0;
    if (page.matches('[data-page-cart]') && count > 0 && !page.querySelector('#CartPageForm') && !instant?.pending) {
      window.location.reload();
      return;
    }
    page.dataset.itemCount = String(count);
    page.dataset.minimumItems = String(minimum);
    const message = page.querySelector('[data-cart-minimum-message]');
    if (message) {
      message.textContent = blocked ? page.dataset.addMore.replace('[count]', String(remaining)) : page.dataset.minimumMet;
    }
    const label = page.querySelector('[data-cart-minimum-label]');
    if (label) label.textContent = page.dataset.minimumLabel.replace('[minimum]', String(minimum));
    const progress = page.querySelector('[data-cart-minimum-progress]');
    if (progress) {
      progress.max = minimum;
      progress.value = Math.min(count, minimum);
      progress.setAttribute('aria-valuetext', page.dataset.countLabel.replace('[count]', String(count)).replace('[minimum]', String(minimum)));
    }
    page.querySelector('[data-cart-minimum]')?.classList.toggle('is-ready', !blocked);
    const checkout = page.querySelector('[name="checkout"]');
    if (checkout) {
      checkout.hidden = false;
      checkout.disabled = blocked;
      checkout.dataset.disabled = String(blocked);
      checkout.setAttribute('aria-disabled', String(blocked));
      checkout.classList.toggle('disable_checkout', blocked);
    }
    page.querySelectorAll('.additional-checkout-buttons').forEach(el => { el.hidden = blocked || instant?.pending; el.style.display = blocked || instant?.pending ? 'none' : ''; });
  }
  updates.push(update);
  document.addEventListener('cart:updated', event => {
    if (event.detail?.cart) update(event.detail.cart.item_count);
  });
  page.addEventListener('submit', event => {
    update();
    if (count < minimumItems()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  update();
  });
  window.fbUpdateMinimum = count => updates.forEach(update => update(count));
})();

